module.exports = __webpack_public_path__ + "static/media/Canvas_508-04.736cc53f.jpg";